<template>
  <div class="all-work__group" v-show="is_show_insale()">
    <input class="all-work__group-input" type="checkbox" v-model="is_sale" id="id_is_sale"/>
    <label class="all-work__group-label" for="id_is_sale">{{ $t("message.ArtworksForSaleSub") }}</label>
  </div>
</template>


<script>
  export default {
    name    : 'filter-insale-sub',

    computed: {
      is_sale: {
        get () {
          return this.$store.getters.is_sale_selected;
        },

        set (value) {
          if (value) {
            this.$store.dispatch ('setFilters', {'p':1, saletype: 'all'}).then (() => { });
          }
          else {
            let params={'p':1, saletype: false};
            if ( this.$store.getters.filters.sort!=null && (this.$store.getters.filters.sort=='price' || this.$store.getters.filters.sort=='low_price') ) params.sort='';
            this.$store.dispatch('setFilters', params).then (() => { });
          }
        },
      }
    },

    methods: {
      is_show_insale(){
        if ( window._GL_works_insale==='n' ) return false;
        return this.$store.getters.is_sale_enable;
      },
    },

    created   : function () {
      this.$store.dispatch ('addUsedFilters', 'Saletypes');
    },
    destroyed : function () {
      this.$store.dispatch ('removeUsedFilters', 'Saletypes');
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/list/filter/FilterInsaleSub.vue